export enum PlasticsCalendarEventType {
    Maintenance = 'Maintenance',
    Other = 'Other',
    Holiday = 'Holiday',
    Overtime = 'Overtime'
}